import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";

import classNames from 'classnames';

import '../css/progressBar.css';

const ProgressBar = ({
  granting,
  committing,
  completed,
  progress
}) => {
  const classes = {
    active: (v) => v ? 'finetune checkmark' : 'circle'
  }

  const pRef = useRef(null);
  const c0 = useRef(null);
  const c1 = useRef(null);
  const c2 = useRef(null);
  const c3 = useRef(null);

  const [ isProgress, setIsProgress ] = useState({
    first: true,
    second: false,
    third: false,
    fourth: false
  });

  useEffect(() => {
    if (progress === 0)
      return;

    setIsProgress({
      ...isProgress,
      second: progress > 1,
      third: progress > 2,
      fourth: progress > 3
    });
  }, [progress]);

  useEffect(() => {
    if (pRef === null || c0 === null || c1 === null || c2 === null || c3 === null)
      return;

    const stepCircles = document.querySelectorAll(".circle");
    const activeCircles = document.querySelectorAll(".active");
    pRef.current.style.width = 
      c0.current.getBoundingClientRect().width * Number(isProgress.second)
      + 1/2*c1.current.getBoundingClientRect().width * Number(isProgress.second)
      + c2.current.getBoundingClientRect().width * Number(isProgress.third)
      + 3/2*c3.current.getBoundingClientRect().width * Number(isProgress.fourth) + 'px';
  }, [isProgress]);

  return (
    <div className="container mv4 mh4">
      <div className="progress-container flex justify-between">
        <div ref={pRef} className="progress" id="progress"></div>
        <div ref={c0} className='flex justify-start w-25'>
          <div className={classNames('f7', classes.active(isProgress.first))}>{isProgress.first ? null : 1}</div>
        </div>
        <div ref={c1} className='flex justify-center w-25'>
          <div className={classNames('f7', classes.active(isProgress.second))}>{isProgress.second ? null : 2}</div>
        </div>
        <div ref={c2} className='flex justify-center w-25'>
          <div className={classNames('f7', classes.active(isProgress.third))}>{isProgress.third ? null : 3}</div>
        </div>
        <div ref={c3} className='flex justify-end w-25'>
          <div className={classNames(classes.active(isProgress.fourth), 'f7')}>{isProgress.fourth ? null : 4}</div>
        </div>
      </div>
      <div className='flex justify-between mv2'>
          <div className='f7 white justify-start'>Create address</div>
          <div className='f7 white'>Grant ETH to address</div>
          <div className='f7 white'>Sign up account</div>
          <div className='f7 white'>Signup has been completed</div>
      </div>
      { granting
        ? <div className='flex justify-center items-center mt4 f3 white blinking'>Setting up address</div>
        : null }
      { committing
        ? <div className='flex justify-center items-center mt4 f3 white blinking'>Committing account</div>
        : null }
      { completed
        ? <div className='flex justify-center items-center mt4 f3 white'>Configuration has been completed</div>
        : null }
    </div>
  )
}

const mapStateToProps = state => ({
  granting: state.login.granting,
  committing: state.login.committing,
  completed: state.login.completed,
  progress: state.login.progress
});

export default connect(mapStateToProps)(ProgressBar);
